import { Flex, HStack, type FlexProps } from '@chakra-ui/react';
import { forwardRef, type ReactNode } from 'react';

const TAB_SCROLL_SX = {
	'&::-webkit-scrollbar': { display: 'none' },
	scrollbarWidth: 'none',
} as const;

/**
 * Parent list tab bar (ENG-2297).
 *
 * This row *is* the TopBar-to-search band. List pages cancel App `p={4}`
 * (`mt={-4}`) and must not put leftover `pt={4}` above this bar — that
 * left 24px above the pills and 8px below. Height is 16 + 32 + 16 so
 * tabs and right-side actions flex-center in that container.
 *
 * Scroll port is the full row height so `overflow-x: auto` does not clip
 * `PendingCountBadge` (`top: -6px`).
 */
export const LIST_TAB_ROW_H = '64px';

export const ListTabRow = forwardRef<HTMLDivElement, FlexProps & { children: ReactNode; actions?: ReactNode }>(
	({ children, actions, ...rest }, ref) => (
		<Flex
			ref={ref}
			align="center"
			px={6}
			h={LIST_TAB_ROW_H}
			flexShrink={0}
			gap={4}
			borderBottom="1px solid"
			borderColor="gray.200"
			{...rest}
		>
			<Flex
				flex="1"
				minW={0}
				h="100%"
				align="center"
				overflowX="auto"
				css={TAB_SCROLL_SX}
			>
				<HStack spacing={1} align="center" h="32px">
					{children}
				</HStack>
			</Flex>
			{actions ? (
				<Flex align="center" h="100%" flexShrink={0}>
					{actions}
				</Flex>
			) : null}
		</Flex>
	),
);
ListTabRow.displayName = 'ListTabRow';

export default ListTabRow;
